const screenComponent = document.getElementsByClassName('screen-section')[0];
if(screenComponent) {
  const bigLogo = screenComponent.querySelector('.screen-section__big-logo');
  const mainLogo = screenComponent.querySelector('.screen-section__main-logo');
  const bigTitleContainer = screenComponent.querySelector('.screen-section__big-title-container');
  const bigTitle = screenComponent.querySelector('.screen-section__big-title');
  const bigTitleSocials = screenComponent.querySelector('.screen-section__holding-socials');
  const wrap = screenComponent.querySelector('.screen-section__wrap');
  const container = screenComponent.querySelector('.screen-section__container');
  const listContainer = screenComponent.querySelector('.screen-section__list-container');
  const mainLink = screenComponent.querySelector('.screen-section__main-link');

  const itemsArr = screenComponent.querySelectorAll('.screen-section__item');
  const contentItemsArr = screenComponent.querySelectorAll('.screen-section__content-item');
  const imagesArr = screenComponent.querySelectorAll('.screen-section__image');

  contentItemsArr.forEach((contentItem, contentItemIdx) => {
    if(contentItemIdx === contentItemsArr.length - 1) {
      const contentItemLastTitle = contentItem.querySelector('.screen-section__content-title');
      contentItemLastTitle.innerHTML = bigTitle.innerHTML;

      /*setTimeout(function () {
        contentItem.classList.add('active');
      }, 4000);*/
    }
  })

  function startAnimation() {
    bigLogo.classList.add('is-start');
    mainLink.classList.add('is-start');
    bigTitleContainer.classList.add('is-start');
    mainLogo.classList.add('is-start');
    wrap.classList.add('is-start');
    container.classList.add('is-start');

    if(bigTitleSocials) {
      bigTitleSocials.classList.add('is-start');
    }
  }

  /*function endAnimation() {
    bigLogo.classList.add('is-end');

    /!*bigTitle.classList.remove('is-start');*!/
    bigTitle.classList.add('is-start');
    mainLogo.classList.add('is-end');
  }*/

  startAnimation();
  setTimeout(function () {
    startAnimation();
  },500);

  let isHoverContainer = false;

  if(listContainer) {
    listContainer.addEventListener('mouseenter', (event) => {
      isHoverContainer = true;
    })

    listContainer.addEventListener('mouseleave', (event) => {
      isHoverContainer = false;
      closeFunction();
    })

    itemsArr.forEach((item, i) => {
      item.addEventListener('mouseenter', (event) => {
        openFunction(item, i);
      })

      item.addEventListener('click', () => {
        if(window.innerWidth <= 1024) {
          if(item.classList.contains('active')) {
            closeFunction();
          } else {
            openFunction(item, i);
          }
        }
      })
    })
  }

  function openFunction(item, i) {
    if(!item.classList.contains('active')) {
      closeFunction();

      item.classList.add('active');
      imagesArr[i].classList.add('active');
      contentItemsArr[i].classList.add('active');
      contentItemsArr[contentItemsArr.length - 1].classList.remove('active');
      mainLogo.classList.add('active');
      mainLink.classList.add('active');
      bigTitle.classList.add('active');

      for (let j = 0; j < itemsArr.length; j++) {
        if(j !== i) {
          itemsArr[j].classList.add('is-hover');
        }
      }
    }
  }

  function closeFunction() {
    for (let k = 0; k < itemsArr.length; k++) {
      imagesArr[k].classList.remove('active');
      contentItemsArr[k].classList.remove('active');
      itemsArr[k].classList.remove('active');
      itemsArr[k].classList.remove('is-hover');
      mainLogo.classList.remove('active');
      mainLink.classList.remove('active');

      if(window.innerWidth >= 641) {
        bigTitle.classList.remove('active');
      } else {
        contentItemsArr[contentItemsArr.length - 1].classList.add('active');
      }
    }
  }
}